import { CircularProgress, makeStyles } from "@material-ui/core";
import React from "react";

import { HelpVideo } from "../../enums/helpVideo";
import { OpenUrlIcon, OpenUrlIconProps } from "../OpenUrlIcon";
import HelpModal from "../pages/help/helpModal";

import { UserMenu } from "./UserMenu";

interface Props {
    children?: any;
    helpVideoNum?: HelpVideo;
    isLoading?: boolean;
    openUrlIconProps?: OpenUrlIconProps;
}

export function PageHeader({
    children,
    helpVideoNum,
    isLoading,
    openUrlIconProps,
}: Props) {
    const classes = useStyles();
    return (
        <header className={classes.header}>
            <div className={classes.heading}>
                <h1>{children}</h1>
                {helpVideoNum != null && <HelpModal videoToFocus={helpVideoNum} />}
                {openUrlIconProps && <OpenUrlIcon {...openUrlIconProps} />}
                {isLoading ? <CircularProgress size={28} /> : <></>}
            </div>
            <UserMenu />
        </header>
    );
};

const useStyles = makeStyles((theme) => ({
    header: {
        color: theme.palette.text.primary,
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "8px",
        paddingBottom: "4px",
        borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: "4px",
        "@media (max-width: 768px)": {
            flexDirection: "column",
            alignItems: "flex-start",
        },
    },
    heading: {
        alignItems: "center",
        gap: "16px",
        display: "flex",
        "& h1": {
            fontSize: "22px",
            fontWeight: 600,
            letterSpacing: "-0.01em",
            margin: "12px 0",
            color: theme.palette.text.primary,
            "@media (max-width: 600px)": {
                fontSize: "18px",
            },
        },
    },
}));
